import CancelDocumentButton from '../Common/CancelDocumentButton';
import { FaDownload, FaEllipsisH, FaFilter, FaUpload } from 'react-icons/fa';
import * as XLSX from 'xlsx';

import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './DeliveryListe.css';
//import InvoiceForm from '../InvoiceFormx';
import { Badge, Button, Card, CardBody, CardHeader, Col, Container, DropdownItem, DropdownMenu, DropdownToggle, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Pagination, PaginationItem, PaginationLink, Row, Spinner, UncontrolledDropdown } from 'reactstrap';
import { FaAngleDoubleLeft, FaAngleDoubleRight, FaAngleLeft, FaAngleRight, FaBoxOpen, FaCalendarAlt, FaCheckCircle, FaClock, FaEdit, FaFileExport, FaFileInvoice, FaFilePdf, FaInfoCircle, FaMoneyBillWave, FaPlus, FaScrewdriver, FaSearch, FaTrash, FaTruck } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { debounce } from 'lodash';
import { devisActions } from '../../sagas/devisSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import { deliveryActions } from '../../sagas/deliveryNoteSlice';
import jsPDF from 'jspdf';
import "jspdf-autotable";
import autoTable from 'jspdf-autotable';
import { convertNumberToWords, formatPrice } from '../../helpers/utility';
import InvoiceForm from './InvoiceForm';
import Select from "react-select";
import { clientActions } from '../../sagas/clientSlice';
import { commercialActions } from '../../sagas/commercialSlice';
import { generateDoc } from '../../helpers/generateDoc';
import { productActions } from '../../sagas/productSlice';
import DocumentPagination from '../Common/DocumentPagination';
import '../Common/DocumentList.css';

const DeliveryList = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const formBase = location.pathname.startsWith('/sales-module') ? '/sales-module/delivery' : '/deliveryNotes/history';
    const dispatch = useDispatch();
    const { list, loading, totalPages, pageNumber, pageSize, totalElements } = useSelector((state) => state.deliveryNotes);
    const { company } = useSelector(state => state.auth);
    const { t } = useTranslation();
    const [checkedDeliveries, setCheckedDeliveries] = useState([]); // State to track checked deliveries
    const [invoice, setInvoice] = useState(null); // State to hold the invoice object
    const [showInvoiceModal, setShowInvoiceModal] = useState(false); // State to control the invoice modal
    const clients = useSelector(state => state.clients.clients);
    const { list: commercialList, loading: commercialLoading } = useSelector((state) => state.commercials); // Adjust state path as needed
    const unites = useSelector(status => status.products.unites); // Assuming you have a Redux store with unites

    const fileInputRef = useRef(null);
    const now = new Date();
    const todayDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const tomorrowDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    const pad = (n) => n.toString().padStart(2, '0');
    const formatDate = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    const getMonthRange = (monthValue) => {
        if (!monthValue) return { dateFrom: formatDate(todayDate), dateTo: formatDate(tomorrowDate) };
        const [year, month] = monthValue.split('-').map(Number);
        const firstDay = new Date(year, month - 1, 1);
        const lastDay = new Date(year, month, 0);
        return { dateFrom: formatDate(firstDay), dateTo: formatDate(lastDay) };
    };
    const [filters, setFilters] = useState({
        clientId: null,
        chantierId: null,
        commercialId: null,
        dateFrom: formatDate(todayDate),
        dateTo: formatDate(tomorrowDate),
        query: '',
        status: '',
        month: '',
        page: 0,
        size: 10
    });
    const [selectedClient, setSelectedClient] = useState(null);

    const searchInputRef = useRef(null);

    useEffect(() => {
        dispatch(clientActions.search({ query: "" }));
        dispatch(commercialActions.list({ query: "" })); // Fetch categories on component mount
        dispatch(productActions.findAllUnites());
    }, []);

    useEffect(() => {
        let payload = {
            ...filters,
        };
        dispatch(deliveryActions.list(payload));
    }, [filters.clientId, filters.chantierId, filters.dateFrom, filters.dateTo, filters.commercialId, filters.status, filters.page, filters.size]);

    useEffect(() => {
        // Auto focus on mount
        searchInputRef.current?.focus();

        // Add keyboard shortcut
        const handleKeyDown = (e) => {
            if (e.key === 'F2') {
                e.preventDefault();
                searchInputRef.current?.focus();
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [list]);

    // Handle checkbox change for delivery selection
    const handleCheckboxChange = (deliveryId) => {
        setCheckedDeliveries((prevChecked) => {
            if (prevChecked.includes(deliveryId)) {
                return prevChecked.filter((id) => id !== deliveryId);
            } else {
                return [...prevChecked, deliveryId];
            }
        });
    };

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            const allowedTypes = [
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'application/vnd.ms-excel'
            ];
            if (!allowedTypes.includes(file.type)) {
                Swal.fire({
                    icon: 'error',
                    title: t('product.invalidFileType'),
                    text: t('product.excelOnly'),
                });
                return;
            }

            try {
                const formData = new FormData();
                formData.append('file', file);

                let payload = {
                    formData: formData,
                    onSuccess: () => {
                        Swal.fire({
                            icon: 'success',
                            title: t('delivery.uploadSuccess'),
                            confirmButtonText: 'OK',
                            confirmButtonColor: '#198754'
                        });
                        refrechBLs();
                    },
                }
                dispatch(deliveryActions.uploadBLs(payload));

            } catch (error) {
                console.error('Error parsing Excel:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Erreur!',
                    text: "Erreur lors de l'importation des produits",
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#dc3545'
                });
            } finally {
                // Reset file input
                if (fileInputRef.current) {
                    fileInputRef.current.value = '';
                }
            }
        }
    };

    const clearFilters = () => {
        setFilters({
            query: '',
            clientId: null,
            chantierId: null,
            commercialId: null,
            dateFrom: formatDate(todayDate),
            dateTo: formatDate(tomorrowDate),
            status: '',
            month: '',
            page: 0,
            size: 10
        });
        debouncedSearch('')
    };

    const clientOptions = clients?.map(client => ({
        value: client.id,
        label: client.typeClient === 'PARTICULIER'
            ? `${client.nom} ${client.prenom || ''} `
            : client.entreprise,
        chantiers: client.chantiers || []
    })) ?? [];

    const clientOptionsWithAll = [
        { value: null, label: t('common.all', 'Tous') },
        ...clientOptions
    ];

    const chantierOptions = selectedClient?.chantiers?.map(chantier => ({
        value: chantier.id,
        label: `${chantier.code} - ${chantier.nom}`,
        ...chantier
    })) || [];

    const chantierOptionsWithAll = [
        { value: null, label: t('common.all', 'Tous') },
        ...chantierOptions
    ];

    const refrechBLs = () => {
        let payload = {
            ...filters,
        };
        dispatch(deliveryActions.list(payload));
    };

    const commercialOptions = commercialList?.map(com => ({
        value: com.id,
        label: com.fullName,
    })) ?? [];

    const commercialOptionsWithAll = [
        { value: null, label: t('common.all', 'Tous') },
        ...commercialOptions
    ];

    // Handle creating an invoice from selected deliveries
    const handleCreateInvoice = () => {
        if (checkedDeliveries.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: t('common.warning'),
                text: t('delivery.noDeliveriesSelected'),
            });
            return;
        }

        // Get the selected delivery notes
        const selectedDeliveryNotes = list.filter(note => checkedDeliveries.includes(note.id));

        // Check if all selected delivery notes are from the same client and are in confirmed state
        const firstClient = selectedDeliveryNotes[0].clientId;
        const allSameClient = selectedDeliveryNotes.every(note => note.clientId === firstClient);
        const allConfirmed = selectedDeliveryNotes.every(note => note.status === 'LIVRE');

        if (!allSameClient) {
            Swal.fire({
                icon: 'warning',
                title: t('common.warning'),
                text: t('delivery.notesFromDifferentClients'),
            });
            return;
        }



        if (!allConfirmed) {
            Swal.fire({
                icon: 'warning',
                title: t('common.warning'),
                text: t('delivery.notAllDelivered'),
            });
            return;
        }

        // Prepare the invoice object
        const newInvoice = {
            clientId: selectedDeliveryNotes[0].clientId,
            clientNom: selectedDeliveryNotes[0].clientNom,
            deliveryMappings: selectedDeliveryNotes.map(note => ({
                id: note.id,
                numero: note.numero,
                dateLivraison: note.dateLivraison,
                montantTTC: note.montantTotalTTC,
                montantPaye: note.montantPaye
            })),
            lignes: (() => {
                const lineMap = {};

                selectedDeliveryNotes.forEach(note => {
                    note.lignes.forEach(line => {

                        const prixTTC = Number(line.prixUnitaireTTC || 0);
                        const tva = line.tauxTVA;

                        // Unique key = article + TTC price
                        const key = `${line.articleId}-${prixTTC}`;

                        if (!lineMap[key]) {
                            lineMap[key] = {
                                articleId: line.articleId,
                                articleCode: line.articleCode,
                                articleNom: line.articleNom,
                                unite: line.unite,
                                prixUnitaireHT: line.prixUnitaireHT,
                                prixUnitaireTTC: prixTTC,
                                tauxTVA: tva,
                                quantite: 0,
                                montantHT: 0,
                                montantTVA: 0,
                                montantTTC: 0,
                            };
                        }

                        const qty = Number(line.quantiteLivree || 0);
                        const puHT = Number(line.prixUnitaireHT || 0);

                        // accumulate
                        lineMap[key].quantite += qty;
                        lineMap[key].montantHT += line.montantHT;
                        lineMap[key].montantTVA += line.montantTVA;
                        lineMap[key].montantTTC += line.montantTTC;
                    });
                });

                return Object.values(lineMap);
            })(),

            montantTotalHT: selectedDeliveryNotes.reduce((total, note) => total + note.montantTotalHT, 0),
            montantTotalTaxe: selectedDeliveryNotes.reduce((total, note) => total + note.montantTotalTaxe, 0),
            montantTotalTTC: selectedDeliveryNotes.reduce((total, note) => total + note.montantTotalTTC, 0),
            montantTotalPaye: selectedDeliveryNotes.reduce((total, note) => total + (note.montantPaye || 0), 0),
            montantRegle: selectedDeliveryNotes.reduce((total, note) => total + (note.montantPaye || 0), 0),
            modePaiement: selectedDeliveryNotes[0].modePaiement,
            modeReglement: selectedDeliveryNotes[0].modeReglement,
            dateFacture: new Date().toLocaleDateString('en-CA', { timeZone: 'Africa/Casablanca' }), // Current date in YYYY-MM-DD format
            dateEcheance: new Date().toLocaleDateString('en-CA', { timeZone: 'Africa/Casablanca' }), // Current date in YYYY-MM-DD format
            // dateEcheanceCheque: selectedDeliveryNotes[0].dateEcheanceCheque,
            // banque: selectedDeliveryNotes[0].banque,
            // numeroCheque: selectedDeliveryNotes[0].numeroCheque,
        };

        setInvoice(newInvoice);
        setShowInvoiceModal(true);
    };


    const handleCloseInvoiceModal = () => {
        setShowInvoiceModal(false);
        setInvoice(null);
        setCheckedDeliveries([]); // Clear checked deliveries after closing the invoice modal
        let payload = {
            ...filters,
        };
        dispatch(deliveryActions.list(payload));
    };

    const handleGeneratePdf = async (document, documentType = 'bon_livraison', withPrices = true) => {
        await generateDoc(documentType, {
            matjarDoc: {
                ...document, lignes: document.lignes.map(l => ({
                    ...l,
                    unite: unites.find(u => u.code === l.unite)?.libelle
                }))
            },
            sellerModel: company,
            currency: "MAD",
            showPrices: withPrices,         // false pour BL sans prix
            open: true,               // ouvre dans un nouvel onglet
            download: false,          // si true -> télécharge
        });
    };


    const handleShowModal = () => navigate(`${formBase}/new`);
    const handleEdit = (document) => navigate(`${formBase}/${document.id}/edit`);

    const debouncedSearch = () => {
        dispatch(deliveryActions.list({
            ...filters,
        }));
    }

    const handleLivrerBL = (bl) => {
        Swal.fire({
            title: t('common.confirm'),
            text: t('bonLivraison.confirmLivrer'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t('common.yes'),
            cancelButtonText: t('common.no'),
        }).then((result) => {
            if (!result.isConfirmed) return;
            let payload = {
                id: bl.id,
                data: { ...bl, status: 'LIVRE' },
                onSuccess: () => {
                    Swal.fire({
                        icon: 'success',
                        title: t('common.updated'),
                        text: t('bonLivraison.updatedSuccess'),
                    });
                    let payload = {
                        ...filters,
                    };
                    dispatch(deliveryActions.list(payload));

                },
            };
            dispatch(deliveryActions.update(payload));
        });
    }

    const handleAccuseBL = (bl) => {
        Swal.fire({
            title: t('common.confirm'),
            text: t('bonLivraison.confirmAccuser'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t('common.yes'),
            cancelButtonText: t('common.no'),
        }).then((result) => {
            if (!result.isConfirmed) return;
            let payload = {
                id: bl.id,
                data: { ...bl, accuse: true },
                onSuccess: () => {
                    Swal.fire({
                        icon: 'success',
                        title: t('common.updated'),
                        text: t('bonLivraison.updatedSuccess'),
                    });
                    let payload = {
                        ...filters,
                    };
                    dispatch(deliveryActions.list(payload));

                },
            };
            dispatch(deliveryActions.update(payload));
        });
    }

    // Aggregate lines by articleId for display/export
    const aggregateLines = (lines) => {
        const lineMap = {};
        lines.forEach(line => {
            const key = line.articleId;
            if (!lineMap[key]) {
                lineMap[key] = {
                    ...line,
                    quantite: 0,
                    montantHT: 0,
                    montantTVA: 0,
                    montantTTC: 0,
                };
            }
            lineMap[key].quantite += line.quantite;
            lineMap[key].montantHT += line.montantHT || (line.quantite * line.prixUnitaireHT);
            lineMap[key].montantTVA += line.montantTVA || (line.quantite * line.prixUnitaireHT * line.tauxTVA);
            lineMap[key].montantTTC += line.montantTTC || (line.quantite * line.prixUnitaireHT * (1 + line.tauxTVA));
        });
        return Object.values(lineMap);
    };

    return (
        <Container fluid>
            <Row className="mb-4">
                <Col>
                    <Card className="shadow-sm">
                        <CardBody className="d-flex justify-content-between align-items-center">
                            <h4 className="mb-0 d-flex align-items-center">
                                <FaTruck className="text-primary me-2" />
                                {t('delivery.list')}
                            </h4>
                            <div className="d-flex align-items-center gap-2">
                                {/* Primary actions */}
                                <Button color="primary" onClick={handleShowModal}>
                                    <FaPlus className="me-2" /> {t('delivery.new')}
                                </Button>
                                {checkedDeliveries.length > 0 && (
                                    <Button color="success" onClick={handleCreateInvoice}>
                                        <FaFileInvoice className="me-2" />
                                        {t('delivery.createInvoice')}
                                    </Button>
                                )}
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Card className="shadow-sm">
                <CardBody>
                    {loading ? ( // Show spinner when loading
                        <div className="text-center py-5">
                            <Spinner color="primary" />
                            <div className="mt-2 text-muted">{t('common.loading')}</div>
                        </div>
                    ) : (
                        <>
                            <div className="filter-container mb-4">
	                                <Row className="mb-3 g-2 align-items-end doc-filter-row">
                                    <Col lg={3} md={3} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label className="mb-1">{t('reglement.search')}</Label>
                                            <div className="input-group">
                                                <span className="input-group-text bg-light">
                                                    <FaSearch />
                                                </span>
                                                <Input
                                                    type="text"
                                                    innerRef={searchInputRef}
                                                    placeholder={t('bonLivraison.searchPlaceholder')}
                                                    value={filters.query}
                                                    onChange={e => {
                                                        const value = e.target.value.toUpperCase();
                                                        setFilters(prevFilters => ({
                                                            ...prevFilters,
                                                            query: value,
                                                            page: 0
                                                        }));
                                                    }}
                                                    className="text-uppercase"
                                                    style={{ textTransform: 'uppercase' }}
                                                    onKeyDown={e => {
                                                        if (e.key === 'Enter') {
                                                            debouncedSearch();
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </FormGroup>
                                    </Col>
                                    <Col md={2}>
                                        <FormGroup className="mb-0">
                                            <Label htmlFor="clientId">{t('bonLivraison.client')}:</Label>
                                            <Select
                                                id="clientId"
                                                options={clientOptionsWithAll}
                                                value={clientOptionsWithAll.find(option => option.value === filters.clientId)}
                                                onChange={(selectedOption) => {
                                                    setFilters(f => ({ ...f, clientId: selectedOption ? selectedOption.value : null, page: 0 }));
                                                    setSelectedClient(selectedOption);
                                                }}
                                                placeholder={t('bonLivraison.selectClient')}
                                                isSearchable
                                                menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 })
                                                }}
	                                            />
	                                        </FormGroup>
	                                    </Col>
	                                    <Col lg={2} md={3} sm={6} xs={12}>
	                                        <FormGroup className="mb-0">
	                                            <Label for="status" className="mb-1">{t('delivery.status')}</Label>
	                                            <Input
	                                                type="select"
	                                                id="status"
	                                                value={filters.status}
	                                                onChange={e => setFilters(f => ({ ...f, status: e.target.value, page: 0 }))}
	                                            >
	                                                <option value="">{t('common.all', 'Tous')}</option>
	                                                <option value="EN_PREPARATION">{t('delivery.enpreparation')}</option>
	                                                <option value="EN_COURS">{t('delivery.encours')}</option>
	                                                <option value="LIVRE">{t('delivery.livre')}</option>
	                                                <option value="ANNULE">{t('commande.statusCancelled')}</option>
	                                            </Input>
	                                        </FormGroup>
	                                    </Col>
	                                    <Col lg={2} md={3} sm={6} xs={12}>
	                                        <FormGroup className="mb-0">
	                                            <Label for="month" className="mb-1">{t('common.month', 'Mois')}</Label>
	                                            <Input
	                                                type="month"
	                                                id="month"
	                                                value={filters.month}
	                                                onChange={e => {
	                                                    const range = getMonthRange(e.target.value);
	                                                    setFilters(f => ({ ...f, month: e.target.value, ...range, page: 0 }));
	                                                }}
	                                            />
	                                        </FormGroup>
	                                    </Col>
	                                    <Col lg={2} md={3} sm={6} xs={12}>
	                                        <FormGroup className="mb-0">
	                                            <Label for="commercialId" className="mb-1">Commercial</Label>
                                            <Select
                                                id="commercialId"
                                                options={commercialOptionsWithAll}
                                                value={commercialOptionsWithAll.find(option => option.value === filters?.commercialId) || null}
                                                onChange={(selectedOption) => setFilters(f => ({ ...f, commercialId: selectedOption ? selectedOption.value : null, page: 0 }))}
                                                placeholder={t('commercial.select', 'Sélectionner...')}
                                                isSearchable
                                                isClearable
                                                menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 })
                                                }}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg={2} md={3} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label for="dateFrom" className="mb-1">Date début</Label>
                                            <Input
                                                type="date"
                                                id="dateFrom"
                                                value={filters.dateFrom}
                                                onChange={e => setFilters(f => ({ ...f, dateFrom: e.target.value, month: '', page: 0 }))}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg={2} md={3} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label for="dateTo" className="mb-1">Date fin</Label>
                                            <Input
                                                type="date"
                                                id="dateTo"
                                                value={filters.dateTo}
                                                onChange={e => setFilters(f => ({ ...f, dateTo: e.target.value, month: '', page: 0 }))}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg={1} md={1} sm={6} xs={12} className="d-flex align-items-end">
                                        <Button
                                            color="secondary"
                                            onClick={clearFilters}
                                            title={t('common.clearFilters')}
                                            className="mb-3"
                                            style={{ minHeight: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                        >
                                            <FaFilter />
                                        </Button>
                                    </Col>
                                </Row>
                            </div>                           


	                            <DocumentPagination
	                                pageNumber={pageNumber}
	                                totalPages={totalPages}
	                                totalElements={totalElements}
	                                pageSize={pageSize}
	                                onPageChange={(page) => setFilters(f => ({ ...f, page }))}
	                            />
	                            <div className="doc-list">
                                {list.length > 0 && (
                                    <div className="doc-row" style={{ gridTemplateColumns: '48px minmax(220px, 1.2fr) minmax(180px, 1fr) minmax(210px, 1fr) minmax(140px, auto) auto' }}>
                                        <div className="doc-row-select">
                                            <Input
                                                type="checkbox"
                                                onChange={(e) => {
                                                    if (e.target.checked) {
                                                        const deliveredIds = list
                                                            .filter(bl => bl.status === 'LIVRE' && !bl.estFacture)
                                                            .map(bl => bl.id);
                                                        setCheckedDeliveries(deliveredIds);
                                                    } else {
                                                        setCheckedDeliveries([]);
                                                    }
                                                }}
                                                checked={
                                                    checkedDeliveries.length > 0 &&
                                                    checkedDeliveries.length === list.filter(bl => bl.status === 'LIVRE' && !bl.estFacture).length
                                                }
                                            />
                                        </div>
                                        <div className="doc-row-main">
                                            <strong>{t('common.totals')}</strong>
                                            <span>{list.length} lignes</span>
                                        </div>
                                        <div className="doc-client" />
                                        <div className="doc-amounts">
                                            <div className="doc-amount">
                                                <span>{t('devis.montantTTC')}</span>
                                                <strong>{formatPrice(list.reduce((sum, bl) => sum + (bl.montantTotalTTC || 0), 0), false)}</strong>
                                            </div>
                                            <div className="doc-amount">
                                                <span>{t('reglement.montantPaye')}</span>
                                                <strong>{formatPrice(list.reduce((sum, bl) => sum + (bl.montantPaye || 0), 0), false)}</strong>
                                            </div>
                                        </div>
                                        <div />
                                        <div />
                                    </div>
                                )}
                                {list.map((bl) => (
                                    <div className="doc-row" key={bl.id} style={{ gridTemplateColumns: '48px minmax(220px, 1.2fr) minmax(180px, 1fr) minmax(210px, 1fr) minmax(140px, auto) auto' }}>
                                        <div className="doc-row-select">
                                            {bl.status === 'LIVRE' && !bl.estFacture && (
                                                <Input
                                                    type="checkbox"
                                                    checked={checkedDeliveries.includes(bl.id)}
                                                    onChange={() => handleCheckboxChange(bl.id)}
                                                />
                                            )}
                                        </div>
                                        <div className="doc-row-main">
                                            <strong>{bl.numero}</strong>
                                            {bl.wooCommerceOrderNumber && <span>Commande WooCommerce : #{bl.wooCommerceOrderNumber}</span>}
                                            <span>{t('commande.dateCreation')}: {bl.createdAt || 'N/A'}</span>
                                            <span>{t('delivery.commercial')}: {bl.commercialNom || 'LOCAL'}</span>
                                        </div>
                                        <div className="doc-client">
                                            <strong>{bl.clientNom || 'N/A'}</strong>
                                            <span>{t('delivery.regle')}: {bl.estRegle ? t('common.yes', 'Oui') : t('common.no', 'Non')}</span>
                                            <span>{t('delivery.facture')}: {bl.estFacture ? t('common.yes', 'Oui') : t('common.no', 'Non')}</span>
                                        </div>
                                        <div className="doc-amounts">
                                            <div className="doc-amount">
                                                <span>{t('devis.montantTTC')}</span>
                                                <strong>{formatPrice(bl.montantTotalTTC, false)}</strong>
                                            </div>
                                            <div className="doc-amount">
                                                <span>{t('reglement.montantPaye')}</span>
                                                <strong>{formatPrice(bl.montantPaye, false)}</strong>
                                            </div>
                                        </div>
                                        <div className="doc-statuses">
                                            {bl.status === 'ANNULE' && <span className="badge bg-danger">Annulé</span>}
                                            {bl.status === 'EN_PREPARATION' && (
                                                <span className="badge bg-warning">{t('delivery.enpreparation')}</span>
                                            )}
                                            {bl.status === 'EN_COURS' && (
                                                <span className="badge bg-secondary">{t('delivery.encours')}</span>
                                            )}
                                            {bl.status === 'LIVRE' && (
                                                <span className="badge bg-success">{t('delivery.livre')}</span>
                                            )}
                                            {bl.status === 'RETOUR' && (
                                                <span className="badge bg-danger">{t('delivery.retourne')}</span>
                                            )}
                                        </div>
                                        <div className="doc-actions">
                                            <CancelDocumentButton document={bl} endpoint={`/api/ventes/bon-livraison/${bl.id}/cancel`} onCancelled={() => dispatch(deliveryActions.list(filters))} />
                                            <UncontrolledDropdown>
                                                <DropdownToggle caret color="secondary" size="sm" className="doc-icon-btn">
                                                    <FaFilePdf />
                                                </DropdownToggle>
                                                <DropdownMenu>
                                                    <DropdownItem onClick={() => handleGeneratePdf(bl, 'bon_livraison', true)}>
                                                        {t('delivery.pdfWithPrices')}
                                                    </DropdownItem>
                                                    <DropdownItem onClick={() => handleGeneratePdf(bl, 'bon_livraison', false)}>
                                                        {t('delivery.pdfWithoutPrices')}
                                                    </DropdownItem>
                                                </DropdownMenu>
                                            </UncontrolledDropdown>
                                            {bl.status === 'EN_PREPARATION' && (
                                                <Button color="success" title={t('bonLivraison.livrer')} onClick={() => handleLivrerBL(bl)} className="doc-icon-btn" size="sm">
                                                    <FaCheckCircle />
                                                </Button>
                                            )}
                                            <Button color="warning" title={t('commande.edit')} disabled={bl.status === 'ANNULE'} onClick={() => handleEdit(bl)} size="sm" className="doc-icon-btn">
                                                <FaEdit />
                                            </Button>
                                        </div>
                                    </div>
                                ))}
                                {list.length === 0 && <div className="doc-empty">{t('delivery.noBL')}</div>}
                            </div>
	                        </>)}
                </CardBody>
            </Card>


            {/* Add Invoice Modal */}
            <Modal isOpen={showInvoiceModal} toggle={handleCloseInvoiceModal} size="xl"
                className="modal-fullscreen-lg-down"
                style={{ maxWidth: '95%', width: '95%', margin: '10px auto' }}
            >
                <ModalHeader toggle={handleCloseInvoiceModal}>
                    {t('facture.newInvoice')}
                </ModalHeader>
                <ModalBody>
                    {invoice && (
                        <InvoiceForm
                            initialValues={invoice}
                            onClose={handleCloseInvoiceModal}
                        />
                    )}
                </ModalBody>
            </Modal>
        </Container>
    );
};

export default DeliveryList;



